import { QueryClient } from '@tanstack/react-query';

const portalQueryClient = new QueryClient();

export default portalQueryClient;
